var module = angular.module('octopusApp.projects');

module.run(function (pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.AzureWebApp", function (octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnServer,
            canChooseRoles: true,
            canHaveChildren: function(){return true;},
            canBeChild: true,
            hasPackages: function(action) { return true; },
            features: {
                optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
                    "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"]
            },
            summaryTemplateUrl: "areas/projects/actions/azure_web_app/Octopus.AzureWebApp_summary.html",
            editTemplateUrl: "areas/projects/actions/azure_web_app/Octopus.AzureWebApp_edit.html",

            preLink: function (scope) {
                scope.account = {
                    AccountId: scope.action.Properties["Octopus.Action.Azure.AccountId"],
                    bound: {}
                };

                scope.site = {
                    resourceGroupName: scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"],
                    name: scope.action.Properties["Octopus.Action.Azure.WebAppName"]
                };

                scope.isAccountBound = function () {
                    return scope.account.bound.isBound;
                };

                scope.getAccountId = function () {
                    return (!scope.isAccountBound()) ? scope.action.Properties["Octopus.Action.Azure.AccountId"] : undefined;
                };

                scope.$watch("action", function (action) {
                    if (action) {
                        if (action.Properties['Octopus.Action.Azure.UseChecksum'] === undefined) {
                            action.Properties['Octopus.Action.Azure.UseChecksum'] = 'False';
                        }
                    }
                });

                scope.$watch(function () {
                        return scope.account.AccountId;
                    },
                    function () {
                        if (scope.action) {
                            scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
                        }
                    });

                scope.$watch(function () {
                        return scope.site.resourceGroupName + "|" + scope.site.name;
                    },
                    function () {
                        if (scope.action) {
                            scope.action.Properties["Octopus.Action.Azure.WebAppName"] = scope.site.name;
                            scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"] = scope.site.resourceGroupName;
                        }
                    });
            },

            summaryLink: function ($scope, element) {
                return octopusRepository.Feeds.get($scope.properties["Octopus.Action.Package.FeedId"]).then(function (feed) {
                    $scope.FeedName = feed.Name;
                });
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_web_app/Octopus.AzureWebApp.js
// module id = 665896048698961
// module chunks = 1